import React, { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import styled from 'styled-components';
import { getStoreSettings } from '../graphql/queries';
import { createStoreSettings, updateStoreSettings } from '../graphql/mutations';
import { Switch, Notification, Message } from 'element-react';

const SettingsContainer = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  max-width: 600px;
  margin-top: 20px;
`;

const SettingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #edf2f7;
  &:last-child {
    border-bottom: none;
  }
`;

const SettingInfo = styled.div`
  flex: 1;
  padding-right: 20px;
`;

const SettingTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #2d3748;
`;

const SettingDesc = styled.p`
  margin: 0;
  font-size: 14px;
  color: #718096;
  line-height: 1.5;
`;

const AdminSettings = () => {
  const [stripeDisabled, setStripeDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data } = await API.graphql(graphqlOperation(getStoreSettings, { id: 'default' }));
      if (data.getStoreSettings) {
        setStripeDisabled(data.getStoreSettings.stripeDisabled);
      }
    } catch (err) {
      console.error('Error fetching store settings:', err);
    }
    setLoading(false);
  };

  const handleToggle = async (value) => {
    setStripeDisabled(value);
    try {
      const input = { id: 'default', stripeDisabled: value };
      
      // Try updating first
      try {
        await API.graphql(graphqlOperation(updateStoreSettings, { input }));
      } catch (updateErr) {
        // If update fails, it means it doesn't exist yet, so create it
        await API.graphql(graphqlOperation(createStoreSettings, { input }));
      }
      
      Notification({
        title: 'Success',
        message: 'Settings updated successfully!',
        type: 'success',
      });
    } catch (err) {
      console.error('Error saving settings:', err);
      Message({ type: 'error', message: 'Failed to update settings.' });
      // Revert the toggle if it fails
      setStripeDisabled(!value);
    }
  };

  return (
    <SettingsContainer>
      <SettingRow>
        <SettingInfo>
          <SettingTitle>Disable Stripe Processing</SettingTitle>
          <SettingDesc>
            Temporarily disable Stripe checkout and refunds. When disabled, customers will skip credit card payments, and cancelled orders will not trigger Stripe API refunds.
          </SettingDesc>
        </SettingInfo>
        <div>
          <Switch
            value={stripeDisabled}
            onChange={handleToggle}
            onColor="#e53e3e"
            offColor="#48bb78"
            onText="ON"
            offText="OFF"
            disabled={loading}
          />
        </div>
      </SettingRow>
    </SettingsContainer>
  );
};

export default AdminSettings;
